module.exports = __webpack_public_path__ + "img/nine.81b82d3f.jpg";